export var StatusOptions;
(function (StatusOptions) {
    StatusOptions["active"] = "active";
    StatusOptions["completed"] = "completed";
    StatusOptions["pending"] = "pending";
    StatusOptions["disabled"] = "disabled";
    StatusOptions["locked"] = "locked";
})(StatusOptions || (StatusOptions = {}));
